/**
 * Display helpers for the Export Requests page (OL-154). Kept free of
 * '@/utils' so they stay unit-testable.
 */

export const STATUS = {
  pending: { label: 'Waiting for approval', badge: 'badge-warning' },
  approved: { label: 'Approved — ready to download', badge: 'badge-success' },
  downloaded: { label: 'Downloaded', badge: 'badge-primary' },
  rejected: { label: 'Rejected', badge: 'badge-danger' },
  expired: { label: 'Expired', badge: '' },
};

export const statusOf = (status) => STATUS[status] ?? { label: status || 'Unknown', badge: '' };

/** A file name built from the request's label, e.g. "Contacts list (xlsx)" → "contacts-list.xlsx". */
export const downloadName = (row) => {
  const base = String(row?.label ?? 'export')
    .replace(/\([^)]*\)/g, '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'export';

  const format = String(row?.format ?? '').toLowerCase();

  return /^[a-z0-9]{2,5}$/.test(format) ? `${base}.${format}` : base;
};

/** Rows an approver can act on come first, then newest first (the API already sorts; this keeps local updates in order). */
export const sortRequests = (rows) =>
  [...(rows ?? [])].sort((a, b) => {
    const pending = (b.status === 'pending') - (a.status === 'pending');
    return pending || String(b.requested_at ?? '').localeCompare(String(a.requested_at ?? ''));
  });
